// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vFprR{flex:1;display:flex;flex-direction:column;min-height:0}.f84Pz{flex:1}.diruW{display:flex;flex-direction:column;min-height:0;overflow:hidden}.hryxs{display:flex;flex-direction:column;min-height:0;overflow:hidden}.Oali7{flex:1;min-height:0;overflow:hidden;position:relative}.eoRsb{flex:1;min-height:0;overflow-y:auto;padding:24px}.oJbNd{flex:1;min-height:0;justify-content:flex-start;align-items:center;container-type:size}.NxIwz{aspect-ratio:16/9;width:min(100%,177.7777777778cqh)}.g00b5{aspect-ratio:16/9;width:min(100%,177.7777777778cqh);display:flex;align-items:center;justify-content:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `vFprR`,
	"card": `f84Pz`,
	"cardPdf": `diruW`,
	"cardText": `hryxs`,
	"content": `Oali7`,
	"richTextContentWrapper": `eoRsb`,
	"videoRoot": `oJbNd`,
	"videoWrapper": `NxIwz`,
	"loaderWrapper": `g00b5`
};
export default ___CSS_LOADER_EXPORT___;
